import React from 'react';
import {
	CopyLink,
	CopyTitle,
	Modal,
	ButtonWrapper,
	ButtonDiv,
	TitleLinkWrapper,
} from './CopyModal.style';
import { useTranslation } from 'react-i18next';
import { ModalTopBg } from '@styles';
import { InviteLinkFilled } from '@assets';

const CopyModal = ({
	isOpen,
	textToCopy,
	setIsOpen,
	handleCopyClick,
}) => {
	const { t } = useTranslation();

	return (
		<Modal
			open={isOpen}
			closable={false}
			style={{
				textAlign: "center",
			}}
			centered={true}
			footer={null}
			width={320}
		>
			<ModalTopBg />
			<InviteLinkFilled id='modal-icon' />
			<TitleLinkWrapper>
				<CopyTitle>{t("profile.inviteLinkModalContent")}</CopyTitle>
				<CopyLink>{textToCopy}</CopyLink>
			</TitleLinkWrapper>
			<ButtonWrapper>
				<ButtonDiv
					type="default"
					onClick={() => setIsOpen(false)}
				>
					{t("common.cancel")}
				</ButtonDiv>
				<ButtonDiv
					type="primary"
					onClick={handleCopyClick}>{t("common.copy")}</ButtonDiv>
			</ButtonWrapper>
		</Modal>
	)
}

export default CopyModal